<div class="container mt-5">
    <div class="row">
      <div class="col-md-12">
          <h4>Contact us</h4>
          
          <p innerHTML="{{value}}"></p>
      </div>
    </div>
</div>
